export const fetchClassTagsReducer = (state, action) => {
  switch (action.status) {
    case 'success': {
      if (action.fetchedTags.length) {
        const classRoom = { ...state.classRooms[action.classRoomId] };

        classRoom.tags = [...action.fetchedTags.map((t) => t.objectId)];

        return {
          ...state,
          classRooms: Object.assign({}, state.classRooms, {
            [classRoom.objectId]: classRoom,
          }),
        };
      }

      return {
        ...state,
      };
    }
    default:
      return state;
  }
};

export const newTagReducer = (state, action) => {
  const { status, tag } = action;
  switch (status) {
    case 'success': {
      const tagId = tag.objectId;
      const classRoomId = tag.classRoom.objectId;
      const classRoom = { ...state.classRooms[classRoomId] };
      classRoom.tags = [...classRoom.tags, tagId];

      return {
        ...state,
        classRooms: Object.assign({}, state.classRooms, {
          [classRoomId]: classRoom,
        }),
      };
    }
    default:
      return state;
  }
};
